var App = App || {};

App.InformationBand = (function ($) {
    'use strict';

    function Init(selector) {
        if (selector.length && selector.find(".splide").length) {
            const carousels = selector.find(".splide");
            if (carousels.length) {
                carousels.each(function () {
                    var carousel = $(this);

                    const splideCarousel = new Splide(carousel[0], {
                        pagination: false,
                        type: 'loop',
                        focus: "center",
                        fixedWidth: "100%",
                        gap: "0px",
                        drag: true,
                        snap: false,
                        perMove: 1
                    });

                    splideCarousel.mount();

                    const currPageIndicator = selector.find(".carousel-navigation .curr-page")
                    const pageCountIndicator = selector.find(".carousel-navigation .page-count")
                    pageCountIndicator.text(splideCarousel.length);

                    const nextBtn = selector.find(".slider-nav.carousel-next");
                    const prevBtn = selector.find(".slider-nav.carousel-prev");

                    nextBtn.on("click", function () {
                        splideCarousel.go('+1')
                    });

                    prevBtn.on("click", function () {
                        splideCarousel.go('-1')
                    });

                    splideCarousel.on('move', function (newIndex) {
                        carousel.find(".splide__slide.appear").removeClass("appear");
                        var newActiveSlide = splideCarousel.Components.Slides.getAt(newIndex).slide;
                        $(newActiveSlide).addClass("appear");
                        currPageIndicator.text(newIndex + 1);
                    });
                });
            }
        }
    }

    return {
        Init: Init
    };

})(jQuery);